module.exports = __webpack_public_path__ + "static/media/headerMyAssetsBg.b9454656.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/headerMyAssetsBg.png
// module id = 1762
// module chunks = 0 1